import React from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import './DesktopStep.css';

const DesktopStep = ({ stepNum, stepDescription, stepId, onClick, enabled, active }) => (
  <div className='desktop-step'>
    <a onClick={() => (enabled ? onClick(stepId) : void null)}>
      <div
        className={ClassNames({
          'desktop-step-marker': true,
          disabled: !enabled,
          active: active,
        })}
      >
        {stepNum}
      </div>
      {stepDescription && active ? <h5>{stepDescription}</h5> : null}
    </a>
  </div>
);

DesktopStep.propTypes = {
  stepNum: PropTypes.number,
  stepDescription: PropTypes.string,
  stepId: PropTypes.string,
  onClick: PropTypes.func,
  enabled: PropTypes.bool,
  active: PropTypes.bool,
};

export default DesktopStep;



// WEBPACK FOOTER //
// ./src/components/navigation/DesktopStep.js